import React from 'react';
import { Box, EmployerDashboardSpendPlaceholderIcon, RawButton, Text } from '@common-fe/common-fe';

interface Props {
  children: React.ReactNode;
  isRequestError?: boolean;
  onTryAgain: () => void;
}
const TotalSpendDashboardPlaceholder: React.FC<Props> = ({ children, isRequestError, onTryAgain }) => {
  if (isRequestError) {
    return (
      <Box align="center" justify="center" height="180px" data-testid="total-spend-placeholder_error">
        <EmployerDashboardSpendPlaceholderIcon size="72px" color="iconDisabled" />
        <Text size="medium" weight={700} margin={{ vertical: 'spacing8' }}>
          We couldn't load your spend data
        </Text>
        <RawButton onClick={onTryAgain} data-testid="total-spend-placeholder_try-again-button">
          <Box pad={{ vertical: 'spacing6', horizontal: 'spacing16' }}>
            <Text color="textAccent" size="medium" weight={400}>
              Try Again
            </Text>
          </Box>
        </RawButton>
      </Box>
    );
  }
  return (
    <Box height="180px" align="center" justify="center" data-testid="total-spend-placeholder_empty">
      <Text size="medium" weight={700}>
        {children}
      </Text>
    </Box>
  );
};

export default TotalSpendDashboardPlaceholder;
